import { render } from "./SignSvg.vue?vue&type=template&id=1118d83f"
const script = {}

import "./SignSvg.vue?vue&type=style&index=0&id=1118d83f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__